const reportPhotosRoutes = [
  {
    path: "reportPhotos",
    name: "Report Photos",
    redirect: {
      name: "Report Photos List"
    },
    component: () =>
      import(/* webpackChunkName: "Photos" */ "../../views/reportPhotos/ReportPhotos.vue"),
    children: [
      {
        path: "list",
        name: "Report Photos List",
        component: () =>
          import(/* webpackChunkName: "Photos" */ "../../views/reportPhotos/ReportPhotosList.vue")
      }
    ]
  }
];

export default reportPhotosRoutes;
